import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
// import apiClient from '../API/apiClient'
// import { applyLogoutMiddleWare } from '../API/middlewares/ApiLogoutMidleware'
import AppReducers from './index';
// applyLogoutMiddleWare(apiClient)
// const persistedReducers = persistReducer(
//   {
//     key: 'REDUX/lusha-plugin',
//     storage,
//     whitelist: [
//       'config',
//     ],
//   },
//   AppReducers,
// )
export const store = configureStore({
    reducer: AppReducers,
    middleware: (getDefaultMiddleware) => {
        const middlewares = getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['FLUSH', 'REHYDRATE', 'PAUSE', 'PERSIST', 'PURGE', 'REGISTER', 'persist/PERSIST'],
            },
        });
        if (process.env.NODE_ENV !== 'production') {
            if (process.env.NODE_ENV !== 'test') {
                middlewares.push(logger);
            }
        }
        return middlewares;
    },
});
window.store = store;
